import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { ConnectedWalletRespMenu } from './ConnectedWalletRespMenu';
import { ConnectedWalletMobileMenu } from './ConnectedWalletMobileMenu';

import { type ConnectedWalletStatus_user$key } from './__generated__/ConnectedWalletStatus_user.graphql';

export const ConnectedWalletStatus: FC<{
    user: ConnectedWalletStatus_user$key;
    isMobile: boolean;
    showEditorial: boolean;
    hideCreate: boolean;
}> = ({ user: userRef, isMobile, showEditorial, hideCreate }) => {
    const user = useFragment(
        graphql`
            fragment ConnectedWalletStatus_user on User {
                ...ConnectedWalletRespMenu_user
                ...ConnectedWalletMobileMenu_user
                ethereumWalletAddress {
                    address
                }
            }
        `,
        userRef
    );
    const { ethereumWalletAddress } = user || {};
    const { address: persistedAddress } = ethereumWalletAddress || {};

    if (!persistedAddress) {
        return null;
    }

    return !isMobile ? (
        <ConnectedWalletRespMenu user={user} hideCreate={hideCreate} />
    ) : (
        <ConnectedWalletMobileMenu
            user={user}
            showEditorial={showEditorial}
            hideCreate={hideCreate}
        />
    );
};
